export { Film as default } from './Film';
